export default "__VITE_ASSET__ZVHhETfu__"